import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ScholarshipModel = () => {
  return (
    <div data-testid="scholarship-model-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-20 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="text-sm font-medium tracking-[0.2em] uppercase text-accent mb-6">
            The Model
          </div>
          <h1 className="text-5xl md:text-6xl font-heading font-semibold tracking-tight leading-[1.05] mb-8">
            Excellence that funds access.
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-primary-foreground/80 max-w-2xl">
            A structural commitment, built into the foundation of our practice.
          </p>
        </div>
      </section>

      {/* Statement */}
      <section className="py-24 md:py-32 bg-background">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl">
          <div className="space-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground">
            <p>
              Lantern Prep operates on a simple premise: families who engage our services directly underwrite the work we do for students who could not otherwise access it.
            </p>
            <p>
              Every founding-cohort engagement contributes to a public commitment of 200 mission hours each year — delivered through scholarship seats in our cohort, free bilingual community workshops in Pinellas and Hillsborough Counties, and pro bono advocacy for families navigating IEP, 504, and testing accommodations.
            </p>
            <p className="text-foreground font-medium">
              The standard of preparation is identical. Scholarship students sit in the same cohort. The model is the difference.
            </p>
          </div>
        </div>
      </section>

      {/* The Numbers / Structure */}
      <section className="py-24 bg-muted">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-16 text-center tracking-tight">
            How it is structured
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="font-heading text-5xl text-accent font-semibold mb-4">200 hrs</div>
              <h3 className="text-xl font-heading font-medium text-primary mb-3">Mission Hours Commitment</h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                A public commitment to scholarship advising, bilingual community workshops, and pro bono accommodations advocacy each year.
              </p>
            </div>

            <div className="text-center">
              <div className="font-heading text-5xl text-accent font-semibold mb-4">100%</div>
              <h3 className="text-xl font-heading font-medium text-primary mb-3">Identical Standard</h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                Scholarship students receive the same curriculum, the same advising team, and the same hours of attention as every other student in the cohort.
              </p>
            </div>

            <div className="text-center">
              <div className="font-heading text-5xl text-accent font-semibold mb-4">501(c)(3)</div>
              <h3 className="text-xl font-heading font-medium text-primary mb-3">Nonprofit Structure</h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                Lantern Prep is a recognized 501(c)(3) nonprofit organization. Every dollar received supports the work — never shareholders or owners.
              </p>
            </div>
          </div>

          <p className="text-center text-base md:text-lg italic text-muted-foreground mt-20 max-w-3xl mx-auto leading-relaxed">
            Scholarship seats carry the same investment as every other seat in the cohort. The standard of preparation is identical because the resources behind it are identical.
          </p>
        </div>
      </section>

      {/* Scholarship Application Block */}
      <section className="py-24 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl">
          <div className="text-sm font-medium tracking-[0.2em] uppercase text-accent mb-6">
            For Scholarship Candidates
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-8 tracking-tight">
            Scholarship Application
          </h2>
          <div className="space-y-5 text-lg leading-relaxed text-primary-foreground/85 mb-10">
            <p>
              Scholarship seats are awarded to students from Pinellas and Hillsborough Counties who meet one or more of the following criteria:
            </p>
            <ul className="list-disc pl-6 space-y-2 marker:text-accent">
              <li>First-generation to college (no parent has completed a four-year degree)</li>
              <li>Family with demonstrated financial need</li>
              <li>Students navigating significant personal or academic circumstances</li>
            </ul>
            <p>
              Selection is based on merit, motivation, and circumstance.
            </p>
            <p>
              The application is detailed by design. We read every submission carefully.
            </p>
          </div>
          <a
            href="/apply"
            data-testid="scholarship-apply-link"
            className="inline-block bg-accent text-accent-foreground px-10 py-4 rounded-sm font-medium tracking-wide hover:bg-accent/90 transition-all"
          >
            Begin Scholarship Application
          </a>
          <p className="text-sm text-primary-foreground/60 mt-6">
            Applications are also available in{' '}
            <a href="/apply/es" className="underline hover:text-accent transition-colors">
              Español
            </a>
            .
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ScholarshipModel;
